import React from "react";
import PropTypes from "prop-types";

import Skeleton from "react-loading-skeleton";
import { COMMENTS_PER_PAGE } from "../totdConfig";

import { getMessageBoardTopicReplies } from "../api/getMessageBoard";

import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import LoadMore from "~/Components/Elements/LoadMore";
import TrackComment from "~/Components/Elements/TrackComment";
import TrackCommentsForm from "~/Components/Elements/Forms/TrackCommentsForm";

class TopicCommentsContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, type: "comment", items: [] };
  }
  fetch = () => {
    this.props.request(this.props.topic.id, this.state.page).then(({ data }) => {
      const hasMore = data && data.length === COMMENTS_PER_PAGE;
      const items = this.state.items.slice(0);
      data.map((t) => items.push(t));
      this.setState({ items, page: (this.state.page += 1), hasMore });
    });
  };
  setReplies = (replies) => {
    this.setState({ ...this.state, items: replies });
  };

  render = () => {
    const { items, hasMore } = this.state;
    const { data, loading, topic } = this.props;

    const comments = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }

    return (
      <React.Fragment>

        <TrackCommentsForm topic={topic} onReply={(replies) => (replies = this.setReplies(replies))} />

        {!loading && items.length > 0 && topic && (
          <div className="totd-header">
            <h3>Comments for {topic.subject}</h3>
          </div>
        )}
        {items &&
          items.map((comment) => (
            <div key={comment.id}>
              <TrackComment addRe={this.state.addRe} comment={comment} type={`comment`} highlight={this.state.filter} />
            </div>
          ))}

        <LoadMore loading={loading} hasMore={hasMore} items={items} pagination={this.pagination} />
      </React.Fragment>
    );
  };
}

TopicCommentsContainer.propTypes = {
  filter: PropTypes.string,
};

export default CreateContainer(getMessageBoardTopicReplies, TopicCommentsContainer);
